/**
 * Community Section - Glider.js Carousel Initialization
 *
 * Initializes all community carousel instances with Glider.js.
 * Supports both initial page load and dynamic block rendering in the editor.
 */
(function () {
	'use strict';

	const initCommunityCarousels = () => {
		const carousels = document.querySelectorAll('.community-section .glider:not(.glider-initialized)');

		carousels.forEach((carousel) => {
			const contain = carousel.closest('.glider-contain');
			if (!contain) return;

			const prevBtn = contain.querySelector('.glider-prev');
			const nextBtn = contain.querySelector('.glider-next');
			const dotsEl = contain.querySelector('.dots');

			// Mark as initialized to prevent double-init
			carousel.classList.add('glider-initialized');

			const glider = new Glider(carousel, {
				slidesToShow: 1,
				slidesToScroll: 1,
				draggable: true,
				dots: dotsEl,
				arrows: {
					prev: prevBtn,
					next: nextBtn,
				},
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});

			// Autocycle every 4 seconds, pause on hover
			let autoplay = setInterval(() => glider.scrollItem('next'), 4000);
			contain.addEventListener('mouseenter', () => clearInterval(autoplay));
			contain.addEventListener('mouseleave', () => {
				autoplay = setInterval(() => glider.scrollItem('next'), 4000);
			});
		});
	};

	// Init on DOM ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initCommunityCarousels);
	} else {
		initCommunityCarousels();
	}

	// Re-init when new blocks are rendered (ACF block editor preview)
	if (typeof wp !== 'undefined' && wp.hooks) {
		wp.hooks.addAction('acf/block/render', 'community-section', initCommunityCarousels);
	}

	// Also observe DOM changes for dynamic loading (front-end only)
	if (document.body && !document.body.classList.contains('block-editor-page')) {
		const observer = new MutationObserver((mutations) => {
			for (const mutation of mutations) {
				if (mutation.addedNodes.length) {
					initCommunityCarousels();
					break;
				}
			}
		});
		observer.observe(document.body, { childList: true, subtree: true });
	}
})();
